import HomePage from "./components/sub/HomePage";
import DynamicPage from "./components/lib/meta/DynamicPage";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import Applynow from "./pages/Applynow";
import Careers from "./components/Careers";
import Blog from "./pages/Blog";
import EmailDisclaimer from "./pages/landing/EmailDisclaimer";
import Propertey from "./pages/landing/Propertey";
import ScrollToTop from "./components/ScrollToTop";
import Privacy from "./pages/landing/Privacy";
import ApplyAttorney from "./components/Forms/Apply-now-Attorney";
import ApplyProperty from "./components/Forms/Apply-now-property";
import PropertyFrom from "./components/PropertyForm";
import RAFAdvance from "./components/Forms/RAF-Advance";
import ContactForm from "./components/Forms/TestForm";
import Topbar from "./components/topBar";
import RAFBridingFinance from "./pages/services/RAF-Bridging-Finance";
import PropertyBridingFinance from "./pages/services/Property-Briding-Finance";
import AttorneyBridgeFinance from "./pages/services/Attorney-Briding-Finance";
import BusinessGrowthFinance from "./pages/services/Business-Growth-Finance";
import ThankYou from "./components/ThankYou";
import ReactGA from "react-ga4";
<head>
  <title>Home</title>
</head>;

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize("G-XXXXXXXXXX"); // Replace with your Measurement ID
    ReactGA.send("pageview"); // Log initial pageview
  }, []);
  return (
    <>
      {/* Elements that appear on all pages */}

      {/* Dynamic Page Content */}
      <DynamicPage
        title="WeBridge – Upfront Payment on Settled RAF Claims"
        description="Webridge"
      />

      {/* Define Routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Careers" element={<Careers />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Propertey" element={<Propertey />} />
        <Route path="/EmailDisclaimer" element={<EmailDisclaimer />} />
        <Route path="/Privacy" element={<Privacy />} />
        <Route path="/RAF-Advance" element={<RAFAdvance />} />
        <Route path="/Applynow" element={<Applynow />} />
        <Route path="/ProperteyForm" element={<PropertyFrom />} />
        <Route path="/Apply-now-Attorney" element={<ApplyAttorney />} />
        <Route path="/Apply-now-property" element={<ApplyProperty />} />
        <Route path="/ContactForm" element={<ContactForm />} />
        <Route path="/ThankYou" element={<ThankYou />} />
        <Route path="/RAF-Briding-Finance" element={<RAFBridingFinance />} />
        <Route
          path="/Property-Briding-Finance"
          element={<PropertyBridingFinance />}
        />
        <Route
          path="/Attorney-Bridging-Finance"
          element={<AttorneyBridgeFinance />}
        />
        <Route
          path="/Business-Growth-Finance"
          element={<BusinessGrowthFinance />}
        />
      </Routes>
    </>
  );
}

export default App;
